export const SECRET_PLACEHOLDER = "•••••••• (đang lưu, để trống nếu không đổi)";
